var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx } from '@emotion/core';
import { facepaintMediaQueries } from '../shared';
import { FONT, COLORS } from '../../constants';
import { useLocalization } from '../../localization';
import * as translations from './localization';
var legendCss = facepaintMediaQueries(__assign(__assign({
  color: COLORS.grays.light
}, FONT.sizes.regular), {
  display: ['block', 'block', 'none']
}));
export var Legend = function Legend(_a) {
  var activeStep = _a.activeStep,
      stepsTotal = _a.stepsTotal;
  var strings = useLocalization(translations).strings;
  var legendText = strings.stepOfSteps.replace('[activeStep]', activeStep.toString()).replace('[stepsTotal]', stepsTotal.toString());
  return jsx("div", {
    css: legendCss
  }, legendText);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Stepper/legend.js
// module id = 1239
// module chunks = 0